import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  get_expiring_raw_data,
  updateProduct,
  updateProductQty,
} from "../../../Utility/Api";
import { NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { Pagination } from "../../Common/Functions";

const Expiry = () => {
  const { selectedWarehouse, showLoader, hideLoader, UserItem,shopItem } =
    useContext(WarehouseContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [expiredProducts, setExpiredProducts] = useState([]);
  const [Expired, setExpired] = useState(1); // 0 = Expired, 1 = Expiring Soon
  const [SearchQurey, setSearchQurey] = useState('');
  const [daysFilter, setDaysFilter] = useState(10); // default 10 days

  useEffect(() => {
    if (shopItem && shopItem.id) {
      fetchExpiredProducts();
    }
  }, [shopItem, Expired]);

  const fetchExpiredProducts = async (page = currentPage, search = SearchQurey, days = daysFilter) => {
    if (!shopItem || !shopItem.id) return;
    
    showLoader();
    try {
      const response = await get_expiring_raw_data(
        page, 
        shopItem.id, 
        search,
        days,
        Expired === 0 ? "expired" : "expiring" // Pass filter type based on tab
      );
      
      console.log("API Response:", response.data);
      
      if (response.data) {
        setExpiredProducts(response.data.data || []);
        setTotalPages(response.data.pagination?.total_pages || 0);
      }
    } catch (error) {
      console.error("Error fetching expired products:", error);
      toast.error("Failed to load expiry data");
      setExpiredProducts([]);
      setTotalPages(0);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (shopItem && shopItem.id) {
      setCurrentPage(1); // Reset to page 1 when search changes
      fetchExpiredProducts(1, SearchQurey, daysFilter);
    }
  }, [SearchQurey, daysFilter, Expired, shopItem]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchExpiredProducts(pageNumber, SearchQurey, daysFilter);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  // const calculateExpiryStatus = (expiryDate) => {
  //   if (!expiryDate) return "Unknown";
    
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
    
  //   const expDate = new Date(expiryDate);
  //   expDate.setHours(0, 0, 0, 0);
    
  //   if (expDate < today) {
  //     return "Expired";
  //   }
    
  //   const differenceInTime = expDate.getTime() - today.getTime();
  //   const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    
  //   if (differenceInDays <= 10) {
  //     return `Expires in ${differenceInDays} days`;
  //   }
    
  //   return "Valid";
  // };

  const calculateExpiryStatus = (expdate) => {
    if (!expdate) return "Unknown";
  
    const today = new Date();
    const expiryDate = new Date(expdate);
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert ms to days
  
    if (diffDays <= 0) return "Expired";
    return `${diffDays} day(s) left`;
  };
  

  return (
    <>
      <div className="">
        <div className="page-wrappers">
          <div className="page-content">
            <NaviGate />
          </div>

          <h6 className="text-uppercase ms-3">Raw Materials Expiry</h6>

          <hr className="mt-1" />
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between flex-wrap">
                {/* Search */}
                <div className="col-12 col-md-4 col-lg-3 mb-3">
                  <div className="d-flex position-relative" style={{ width: "100%" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      onChange={(e) => setSearchQurey(e.target.value)}
                      value={SearchQurey}
                    />
                    <img
                      src="/assets/images/icons/search.png"
                      alt="Search Icon"
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "18px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                {/* Days Filter and Tabs */}
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <select
                    className="form-select form-select-sm"
                    value={daysFilter}
                    onChange={(e) => setDaysFilter(e.target.value)}
                  >
                    <option value="">Today</option>
                    <option value="5">5 Days</option>
                    <option value="10">10 Days</option>
                    <option value="30">30 Days</option>
                  </select>
                
                  {/* Tabs */}
                  {/* <div className="tab-container">
                    <button
                      className={`tab-button ${Expired === 0 ? "active-tab" : ""}`}
                      onClick={() => setExpired(0)}
                    >
                      Expired
                    </button>
                    <button
                      style={{ width: "max-content" }}
                      className={`tab-button ${Expired === 1 ? "active-tab" : ""}`}
                      onClick={() => setExpired(1)}
                    >
                      Expires Soon
                    </button>
                  </div> */}
                </div>
              </div>

              <div className="table-responsive">
                <table
                  id="example"
                  className="table table-sm table-bordered align-baseline"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Raw Material</th>
                      <th>Quantity</th>
                      <th>Remaining Quantity</th>
                      <th>Expiry Date</th>
                      <th>Expiry Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expiredProducts && expiredProducts.length > 0 ? (
                      expiredProducts.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * 10 + index + 1}</td>
                          <td>{formatDate(item.date_time)}</td>
                          <td>{item.raw_material_title}</td>
                          <td>{item.qty} {item.unit}</td>
                          <td>{Number(item.remaining).toFixed(2)} {item.unit}</td>
                          <td className={Expired === 0 ? "text-danger" : ""}>
                            {item.expdate}
                          </td>
                          <td>
  <span
    className={`badge ${
      Expired === 0 ? "bg-danger" : "bg-warning"
    }`}
  >
    {Expired === 0 ? "Expired" : calculateExpiryStatus(item.expdate)}
  </span>
</td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-3">
                          No {Expired === 0 ? "expired" : "expiring"} raw materials found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Expiry;
